// layers/pdarAoaLines.ts
import type { LayerSpecification } from "maplibre-gl";
import { SOURCES } from "../sources";
import { LAYERS } from "./constants";

export const pdarAoaLines: LayerSpecification = {
  id: LAYERS.PDAR_AOA || "pdar-aoa-layer",
  type: "line",
  source: SOURCES.PDAR_AOA || "pdar-aoa-source",
  layout: {
    "line-join": "round",
    "line-cap": "round",
  },
  paint: {
    // 🎨 Per-line `color` override wins; otherwise fall back to the health_state palette.
    "line-color": [
      "coalesce",
      ["get", "color"],
      [
        "match",
        ["get", "health_state"],
        "nominal",
        "#7c3aed", // High-Vis Tactical Green (Matches sensor markers)
        "warning",
        "#FFA500", // Amber
        "critical",
        "#FF3333", // Solid Red
        "offline",
        "#757575", // Muted Grey
        "#65a30d", // Fallback Default
      ],
    ],
    // 📏 Thicker lines when the parent sensor station is actively selected
    "line-width": [
      "case",
      ["boolean", ["get", "isSensorSelected"], false],
      2.0, // Selected emphasis
      1, // Standard target tracking stroke
    ],
    // 💨 Per-line `opacity` override wins; otherwise fall back to selection-based fade.
    "line-opacity": [
      "coalesce",
      ["get", "opacity"],
      ["case", ["boolean", ["get", "isSensorSelected"], false], 0.85, 0.5],
    ],
  },
};
